"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var services_1 = require("@falcon/services");
var CoversHelper_1 = require("../../helpers/CoversHelper");
var Tree_1 = require("../../components/Tree");
var LimitsTree = /** @class */ (function (_super) {
    __extends(LimitsTree, _super);
    function LimitsTree(props) {
        var _this = _super.call(this, props) || this;
        _this.renderLimits = function () {
            var limits = [];
            var coverTier = _this.props.interaction.coverTier;
            for (var _i = 0, _a = _this.props.coverage.amounts; _i < _a.length; _i++) {
                var amount = _a[_i];
                if (CoversHelper_1.CoversHelper.limitRegex.test(amount.amountCode) && CoversHelper_1.CoversHelper.notInExcludedList(amount.amountCode)) {
                    _this.props.interaction.product === services_1.PRODUCT_ANNUAL_HOME
                        ? _this.pushHomeLimit(limits, amount, coverTier)
                        : _this.pushMotorLimit(limits, amount, coverTier);
                }
            }
            if (limits.length > 0
                && _this.props.interaction.product === services_1.PRODUCT_ANNUAL_HOME
                && _this.props.interaction.coverTier !== services_1.BRONZE_TIER) {
                limits.push(CoversHelper_1.CoversHelper.getProfessionalRemovalDiv());
            }
            return limits.length > 0 ? limits : null;
        };
        return _this;
    }
    LimitsTree.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Limits", children: this.renderLimits() }));
    };
    LimitsTree.prototype.pushMotorLimit = function (limits, amount, coverTier) {
        limits.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [amount.amountText, " ", CoversHelper_1.CoversHelper.getAmountWording(coverTier, amount.amountCode, amount.amount)] }) }, amount.amountCode));
    };
    LimitsTree.prototype.pushHomeLimit = function (limits, amount, coverTier) {
        limits.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [CoversHelper_1.CoversHelper.homeLimitTypes[amount.amountCode], " ", CoversHelper_1.CoversHelper.getAmountWording(coverTier, amount.amountCode, amount.amount)] }) }, amount.amountCode));
    };
    LimitsTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], LimitsTree);
    return LimitsTree;
}(React.Component));
exports.default = LimitsTree;
//# sourceMappingURL=LimitsTree.js.map